import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Seo } from "../components/Seo";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy grain flex items-center justify-center px-6 relative overflow-hidden">
      <Seo title="Admin Sign In | Next Horizon Builders" description="Next Horizon Builders admin portal." path="/admin/login" noindex />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <img src="/media/logo-white.png" alt="Next Horizon Builders" className="h-20 w-auto mx-auto mb-6" />
          <p className="eyebrow">Admin Portal</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white p-10 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={20} className="text-gold" />
            <h1 className="font-serif font-light text-3xl text-navy">Sign In</h1>
          </div>
          <label className="block text-[0.68rem] uppercase tracking-[0.2em] text-darkgray/50 font-semibold mb-2">Email</label>
          <input
            data-testid="admin-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-gray-300 py-3 mb-6 focus:border-gold focus:outline-none transition-colors font-light"
            placeholder="admin@nexthorizonbuilders.com"
          />
          <label className="block text-[0.68rem] uppercase tracking-[0.2em] text-darkgray/50 font-semibold mb-2">Password</label>
          <input
            data-testid="admin-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-gray-300 py-3 mb-10 focus:border-gold focus:outline-none transition-colors font-light"
            placeholder="••••••••"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group w-full inline-flex items-center justify-center gap-3 bg-navy text-white px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] hover:bg-gold transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>
      </div>
    </div>
  );
}
